(function () {
  'use strict';
  const COLUMN_PROFILE_HANDLES = [
    'ltsg-2118-closet-support-column',
    'arc-wardrobe-support-column-3000mm-copy',
    'arc-column-base-mount-yf-658'
  ];

  const currentHandle = window.location.pathname
    .split('/products/')[1]
    ?.split('/')[0]
    ?.toLowerCase();

  if (COLUMN_PROFILE_HANDLES.includes(currentHandle)) {
    document.body.classList.add('ae-column-profile');
  }function hideColumnProfilePurchaseControls() {
  if (!COLUMN_PROFILE_HANDLES.includes(currentHandle)) return;

  const selectors = [
    '#product-add-to-cart',
    '.product-form__submit',
    '.quantity',
    '.product-form__quantity',
    '[data-testid="shopify-installments"]',
    '#shopify-installments'
  ];

  selectors.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (element) {
      element.style.display = 'none';
    });
  });
}
  const PRODUCTS = {
    'ltsg-2118-closet-support-column': {
      rate: 22,
      max: 98.4
    },

    'arc-wardrobe-support-column-3000mm-copy': {
      rate: 13,
      max: 98.4
    },

    'arc-column-base-mount-yf-658': {
      rate: 20,
      max: 118.1
    }
  };

  function getProductSettings() {
    const path = window.location.pathname.toLowerCase();

    for (const handle in PRODUCTS) {
      if (path.includes(handle)) {
        return PRODUCTS[handle];
      }
    }

    return null;
  }

  function findHeightInput() {
    return document.querySelector(
      'input[placeholder*="finished height" i]'
    );
  }

  function updateCalculator() {
    const settings = getProductSettings();
    const input = findHeightInput();

    if (!settings || !input) return;

    let resultBox = document.querySelector('.ae-cut-price-calculator');

    if (!resultBox) {
      resultBox = document.createElement('div');
      resultBox.className = 'ae-cut-price-calculator';

      resultBox.style.marginTop = '10px';
      resultBox.style.padding = '14px 18px';
      resultBox.style.background = '#f5f5f5';
      resultBox.style.border = '1px solid #ddd';
      resultBox.style.fontSize = '16px';
      resultBox.style.lineHeight = '1.5';

      input.parentElement.insertAdjacentElement(
        'afterend',
        resultBox
      );
    }

    const inches = parseFloat(input.value);

    if (!inches || inches <= 0) {
      resultBox.style.display = 'none';
      return;
    }

    const feet = inches / 12;
    const total = feet * settings.rate;

    resultBox.style.display = 'block';

    resultBox.innerHTML = `
      <strong>Estimated Cut Price:</strong>
      $${total.toFixed(2)}
      <div style="font-size:14px; margin-top:3px; color:#666;">
        ${inches.toFixed(2)}" ÷ 12 × $${settings.rate}/linear ft
      </div>
    `;
  }

  function initializeCalculator() {
    const input = findHeightInput();

    if (input && !input.dataset.aeCalculatorAttached) {
      input.dataset.aeCalculatorAttached = 'true';

      input.addEventListener('input', updateCalculator);
      input.addEventListener('change', updateCalculator);

      updateCalculator();
    }
  }

  // Easify can load/change the field dynamically.
  const observer = new MutationObserver(function () {
    initializeCalculator();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  initializeCalculator();
hideColumnProfilePurchaseControls();

const purchaseObserver = new MutationObserver(function () {
  hideColumnProfilePurchaseControls();
});

purchaseObserver.observe(document.body, {
  childList: true,
  subtree: true
  
});
})();